import { WeightDisplay } from './WeightDisplay';

export default WeightDisplay;


// WEBPACK FOOTER //
// ./src/components/WeightDisplay/index.tsx